import * as MutationsType from "./mutationsType";
import requestAxios from "@/helpers/request_axios";

export default {
  async getAllCalendars({ commit }) {
    let response = await requestAxios({
      url: "/awy/api/v1/calendars",
      method: "GET",
    });

    commit(MutationsType.SET_CALENDARS, response.data.data);
  },
  async getCalendarById({ commit }, { id }) {
    let response = await requestAxios({
      url: `/awy/api/v1/calendars/${id}`,
      method: "GET",
    });

    commit(MutationsType.SET_CALENDAR_SELECTED, response.data.data);
    commit(MutationsType.SET_CALENDAR, response.data.data);
  },
  async saveCalendar({ commit }, { data }) {
    let response = await requestAxios({
      url: "/awy/api/v1/calendars",
      method: "POST",
      data: data,
    });

    commit(MutationsType.SET_CALENDAR, response.data.data);

    return response.data;
  },
  async updateCalendar({ commit }, { id, data }) {
    let response = await requestAxios({
      url: `/awy/api/v1/calendars/${id}`,
      method: "PATCH",
      data: data,
    });

    commit(MutationsType.UPDATE_CALENDAR, response.data.data);

    return response.data;
  },
  async enableCalendar({ rootState, commit }) {
    let response = await requestAxios({
      url: "/awy/api/v1/calendars/enable",
      method: "POST",
    });

    let data = response.data;

    commit(MutationsType.SET_CALENDAR, data.data);
    commit(
      "UPDATE_AGENT",
      {
        uid: rootState.Agent.agent.uid,
        calendar_id: data.data.id,
      },
      { root: true },
    );

    return data;
  },
  resetCalendarSelected({ commit }) {
    commit(MutationsType.SET_CALENDAR_SELECTED, null);
  },
  resetModuleCalendar({ commit }) {
    commit(MutationsType.SET_CALENDAR, null);
    commit(MutationsType.SET_CALENDARS, null);
  },
};
